import { render, staticRenderFns } from "./ProjectListTable.vue?vue&type=template&id=aedd7dbe&scoped=true&"
import script from "./ProjectListTable.vue?vue&type=script&lang=js&"
export * from "./ProjectListTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListTable.vue?vue&type=style&index=0&id=aedd7dbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedd7dbe",
  null
  
)

export default component.exports